import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=68647478&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=68647478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68647478",
  null
  
)

export default component.exports